var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 2.33333C2.17293 2.33333 2.58333 1.92293 2.58333 1.41667C2.58333 0.910406 2.17293 0.5 1.66667 0.5C1.16041 0.5 0.75 0.910406 0.75 1.41667C0.75 1.92293 1.16041 2.33333 1.66667 2.33333Z",
    fill: "#861DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 6.91683C2.17293 6.91683 2.58333 6.50642 2.58333 6.00016C2.58333 5.4939 2.17293 5.0835 1.66667 5.0835C1.16041 5.0835 0.75 5.4939 0.75 6.00016C0.75 6.50642 1.16041 6.91683 1.66667 6.91683Z",
    fill: "#861DF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 11.4998C2.17293 11.4998 2.58333 11.0894 2.58333 10.5832C2.58333 10.0769 2.17293 9.6665 1.66667 9.6665C1.16041 9.6665 0.75 10.0769 0.75 10.5832C0.75 11.0894 1.16041 11.4998 1.66667 11.4998Z",
    fill: "#861DF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3887 5.0835H5.27866C4.80277 5.0835 4.41699 5.46928 4.41699 5.94516V6.05516C4.41699 6.53105 4.80277 6.91683 5.27866 6.91683H16.3887C16.8645 6.91683 17.2503 6.53105 17.2503 6.05516V5.94516C17.2503 5.46928 16.8645 5.0835 16.3887 5.0835Z",
    fill: "#861DF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3887 9.6665H5.27866C4.80277 9.6665 4.41699 10.0523 4.41699 10.5282V10.6382C4.41699 11.1141 4.80277 11.4998 5.27866 11.4998H16.3887C16.8645 11.4998 17.2503 11.1141 17.2503 10.6382V10.5282C17.2503 10.0523 16.8645 9.6665 16.3887 9.6665Z",
    fill: "#861DF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3887 0.5H5.27866C4.80277 0.5 4.41699 0.885781 4.41699 1.36167V1.47167C4.41699 1.94755 4.80277 2.33333 5.27866 2.33333H16.3887C16.8645 2.33333 17.2503 1.94755 17.2503 1.47167V1.36167C17.2503 0.885781 16.8645 0.5 16.3887 0.5Z",
    fill: "#861DF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.c43718512185bbb76ec9fb549e64cc69.svg";
export { ForwardRef as ReactComponent };